<template>
    <!-- 对话框 -->
    <el-dialog :title="name + '的账单'" :visible.sync="show" :before-close="closeDialog" width="90%">
        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column prop="id" label="id"> </el-table-column>
            <el-table-column prop="amount" label="金额"> </el-table-column>
            <el-table-column prop="description" label="描述"> </el-table-column>
            <el-table-column prop="time.YmdHis" label="操作时间"> </el-table-column>
            <el-table-column prop="mode_name" label="账本模式"> </el-table-column>
            <el-table-column prop="record_code" label="订单"> </el-table-column>
        </el-table>
        <!-- element ui 原生分页组件 -->
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data_children.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="search_data_children.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="result_data_children.count"
            >
            </el-pagination>
        </div>

        <div style="display: flex; justify-content: center">
            <el-button
                type="primary"
                :icon="progress_show ? 'el-icon-loading' : 'el-icon-setting'"
                @click="toExport"
                :disabled="progress_show"
                >{{ progress_show ? '导出中...' : '导出' }}</el-button
            >

            <el-button @click="closeDialog">关闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
var _this;

export default {
    props: {
        isShow: Boolean,
        data: '',
        name: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            _this.search_data_children.account_code = _this.data;

            _this.thirdAccountRecordLists();
        }
    },
    data() {
        return {
            show: false,

            progress_show: false,

            excelData: [],

            excelHead: [],

            tableData: [],

            //翻页数据
            search_data_children: {
                page: 1,
                limit: 10,
                account_code: '',
                fixed_array: '',
                operation: ''
            },

            result_data_children: [],
            search_rules_children: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        toExport() {
            _this.search_data_children.page = 1;
            _this.getExcelData();
        },

        getExcelData() {
            _this.progress_show = true;
            _this
                .$post('/Cooperatewine/thirdAccountRecordLists', _this.search_data_children)
                .then((res) => {
                    if (this.$route.path == '/thirdAccount') {
                        console.log(res.data);
                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.result.length; i++) {
                            _this.excelData.push({
                                amount: res.data.result[i].amount,
                                description: res.data.result[i].description,
                                time: res.data.result[i].time.YmdHis,
                                mode: res.data.result[i].mode_name,
                                record_code: res.data.result[i].record_code
                            });
                        }

                        if (_this.search_data_children.page * _this.search_data_children.limit < res.data.count) {
                            _this.search_data_children.page = _this.search_data_children.page + 1;
                            _this.getExcelData();
                        } else {
                            // 将数据导出execl
                            _this.exportData();
                            _this.search_data_children.page = 1;
                            // 清空数据
                            _this.excelData = [];
                            _this.progress_show = false;
                        }
                    } else {
                        _this.progress_show = false;
                    }
                })
                .catch((err) => {});
        },

        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            const tHeader = ['金额', '描述', '操作时间', '账本模式', '订单'];
            const filterVal = ['amount', 'description', 'time', 'mode', 'record_code'];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, '三方账单导出');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },

        thirdAccountRecordLists() {
            _this
                .$post('/Cooperatewine/thirdAccountRecordLists', _this.search_data_children, _this.search_rules_children)
                .then((res) => {
                    // 将获取到的数据赋值

                    _this.tableData = res.data.result;
                    _this.result_data_children = res.data;
                    console.log(res.data);
                })
                .catch((err) => {});
        },
        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.search_data_children = {
                page: 1,
                limit: 10,
                account_code: '',
                fixed_array: '',
                operation: ''
            };
        },

        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            _this.search_data_children.limit = val;

            //初始化列表
            _this.thirdAccountRecordLists();
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data_children.page = val;

            //初始化列表
            _this.thirdAccountRecordLists();
        },
        //翻页组件的回调
        pages_function() {
            //初始化列表
            _this.thirdAccountRecordLists();
        }
    }
};
</script>

<style scoped>
.form-box {
    padding: 20px;
    box-sizing: brecord_code-box;
    margin-right: 0;
    width: 100%;
}
</style>
